import { render, staticRenderFns } from "./gRechargeRecord.vue?vue&type=template&id=654cd179&scoped=true"
import script from "./gRechargeRecord.vue?vue&type=script&lang=js"
export * from "./gRechargeRecord.vue?vue&type=script&lang=js"
import style0 from "./gRechargeRecord.vue?vue&type=style&index=0&id=654cd179&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654cd179",
  null
  
)

export default component.exports